import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import AvailableCampaignsToAnswer from '@Components/survey/AvailableCampaignsToAnswer/AvailableCampaignsToAnswer';
import OldCampaigns from '@Components/survey/OldCampaigns/OldCampaigns';

const ToolSurveyPageIndex: React.FC<ToolSurveyPageIndexProps> = ({isLoading}) => {

  React.useEffect(() => {
  }, []);

  if (isLoading)
    return <div className="loader"></div>

  return <>
    <div className="text-center mt-5">
      <h1>We need your help!</h1>
      <p>To help the team to balance each army, we need your help to find the true value of each unit, special item,
        options....</p>
    </div>
    <AvailableCampaignsToAnswer/>
    <OldCampaigns/>
  </>
};

const mapStateToProps = (state: AppState) => ({
  isLoading: false
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolSurveyPageIndex);

type ToolSurveyPageIndexProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>